import { useEffect, useState } from "react";
import getRecommendations from "../../api/mightLikeApi";
import { useIsInStockContext } from "../../context/isInStock/IsInStockContext";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import {
  isProductDiscontinued,
  isProductUnavailableForUS,
} from "../../../utils/productUtils";

export default function useRecommendations({ productId, scope }) {
  const { isStockStateReady, isInStock } = useIsInStockContext();
  const { isMixAndMatch, product, storeCode } = useRuntimeConstants();

  const isDiscontinued = isProductDiscontinued(product);
  const isUnavailableForUS = isProductUnavailableForUS(product, storeCode);

  const [mightLikeProducts, setMightLikeProducts] = useState(null);
  const [hasFetchedRecs, setHasFetchedRecs] = useState(false);
  const [apiFailed, setApiFailed] = useState(false);
  const [fetchedProductId, setFetchedProductId] = useState(null);

  useEffect(() => {
    if (isMixAndMatch || !isStockStateReady || !productId) {
      return;
    }

    getRecommendations({
      isInStock,
      isDiscontinued,
      isUnavailableForUS,
      scope,
      productId,
      handleErrorReturnValue: () => {
        setApiFailed(true);
      },
    }).then((products) => {
      setMightLikeProducts(products);
      setHasFetchedRecs(true);
      setFetchedProductId(productId);
    });
  }, [
    productId,
    isMixAndMatch,
    isStockStateReady,
    isInStock,
    isDiscontinued,
    isUnavailableForUS,
    scope,
  ]);

  useEffect(() => {
    if (productId !== fetchedProductId) {
      setApiFailed(false);
      setHasFetchedRecs(false);
      setMightLikeProducts(null);
    }
  }, [productId, fetchedProductId]);

  return { mightLikeProducts, hasFetchedRecs, apiFailed };
}
